import React, { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const DialogBox = ({ open, setOpen, value, setValue, members }) => {
  const handleWin = (winner) => {
    setOpen(false);
    setValue((pre) => {
      return {
        ...pre,
        won: winner,
        score_up_group: winner,
        score_up_value: "SD",
        score_up: false,
        sudden_death: true,
      };
    });
    // alert(`${winner} Win the Match`);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      PaperProps={{ sx: { minWidth: "576px" } }}
    >
      <DialogTitle
        sx={{
          textAlign: "center",
          fontSize: "22px",
          fontWeight: "bold",
          letterSpacing: "2x",
        }}
      >
        Who is the winner?
      </DialogTitle>
      <DialogContent sx={{ display: "flex", marginY: "20px" }}>
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#0000FF",
            marginRight: "5px",
            fontWeight: "bold",
            letterSpacing: "2px",
          }}
          fullWidth
          onClick={() => handleWin("group1")}
          size="large"
        >
          {members[0]?.name} <br />
          {members[1]?.name}
        </Button>
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#FF0000",
            fontWeight: "bold",
            letterSpacing: "2px",
          }}
          fullWidth
          onClick={() => handleWin("group2")}
          size="large"
        >
          {members[2]?.name} <br />
          {members[3]?.name}
        </Button>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogBox;
